<template>
  <div>
    <div>
      <b-card-actions
        title="Filters"
        action-collapse
        collapsed
      >
        <b-row>
          <b-col cols="3">
            <b-form-group
              label="Name"
              label-for="v-name"
            >
              <b-form-input
                id="v-name"
                v-model="filters['name']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              label="Ref No"
              label-for="v-ref-no"
            >
              <b-form-input
                id="v-ref-no"
                v-model="filters['ref_no']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Apply and Clear Filters -->
        <b-row class="mt-1">
          <b-col>
            <filter-buttons
              :filter-data="filters"
              :apply-filters="applyFilters"
              :clear-filters="clearFilters"
            />
          </b-col>
        </b-row>
      </b-card-actions>
    </div>
    <div>
      <b-card
        no-body
      >
        <div>
          <div
            class="m-2"
          >
            <!-- input -->
            <b-row>
              <b-col
                md="8"
                class="d-flex align-items-center justify-content-start mb-1 mt-1 mb-md-0"
              >
                <b-button
                  v-can="'state-create'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  class="custom-button-color"
                  @click="onClickCreateState"
                >
                  <feather-icon icon="PlusIcon" />
                  Add New
                </b-button>
                <b-col
                  md="5"
                >
                  <b-button
                    v-can="'state-create'"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="gradient-success"
                    to="state/state-excel"
                  >
                    <feather-icon icon="PlusIcon" />
                    Excel Upload
                  </b-button>
                </b-col>
              </b-col>
              <b-col
                class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
              >
                <ReportTableButtons
                  class="mt-2"
                  :items="rows"
                  :json_fieldz="json_fields"
                  :name="`State - Page ${page}.xls`"
                  :bulkname="`State.xls`"
                  :fetch="fetchStateNoPagination"
                  @refresh="onClickRefresh"
                />
              </b-col>
            </b-row>
          </div>

          <!-- table -->
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <b-table
              :fields="fields"
              :items="rows"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              hover
              responsive
              striped
              show-empty
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #cell(name)="data">
                <div class="d-flex align-items-center">
                  <b-avatar
                    :text="avatarText(data.item.name)"
                    size="32"
                    variant="light-primary"
                  />
                  <div>
                    <div class="font-weight-bolder ml-1">
                      {{ data.item.name }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ data.item.ref_no }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(state_code)="data">
                {{ data.value || '---' }}
              </template>
              <template #cell(country)="data">
                {{ data.item.country.name }}
              </template>
              <template #cell(action)="data">
                {{ data.value }}
                <b-dropdown
                  no-caret
                  toggle-class="text-decoration-none"
                  variant="link"
                >
                  <template v-slot:button-content>
                    <feather-icon
                      class="text-body align-middle mr-25"
                      icon="MoreVerticalIcon"
                      size="12"
                    />
                  </template>
                  <b-dropdown-item
                    v-can="'state-edit'"
                    @click="onClickUpdate(data.item.id)"
                  >
                    <feather-icon icon="ToolIcon" />
                    Manage State
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-can="'state-delete'"
                    @click="onClickDelete(data.item.id)"
                  >
                    <feather-icon icon="Trash2Icon" />
                    Delete State
                  </b-dropdown-item>
                </b-dropdown>
              </template>

            </b-table>
          </b-overlay>
          <div class="mx-2 mb-2">
            <b-row>

              <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-sm-start"
              >
                <label class="width-75">Per page</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block ml-1 width-100 mr-2"
                />
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                md="9"
                class="d-flex align-items-center justify-content-sm-end"
              >
                <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                <b-pagination
                  v-model="page"
                  :total-rows="(meta.total)? meta.total : 0"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>

              </b-col>

            </b-row>
          </div>
        </div>
      </b-card>
    </div>
    <set-state ref="set_state" />
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
  BOverlay,
  VBModal,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import vSelect from 'vue-select'
import { avatarText } from '@core/utils/filter'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import store from '@/store'
import SetState from '@/components/demarcation/SetStateModal.vue'
import FilterButtons from '@/components/Filter/FilterButtons.vue'

const ResourceRepository = RepositoryFactory.get('resource')

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    BFormGroup,
    BFormInput,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BOverlay,
    BPagination,
    vSelect,
    BDropdown,
    BDropdownItem,
    BAvatar,
    SetState,
    BCardActions,
    FilterButtons,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage],
  data() {
    return {
      avatarText,
      filters: {},
      total: 0,
      meta: {},
      dataLoading: false,
      // Start BS Table
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      form: {},
      showUpdateModal: false,
      modelLoading: false,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      dir: false,
      recordId: 0,
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
          thClass: 'd-none',
          tdClass: 'd-none',
        },
        {
          key: 'name',
          label: 'State',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'state_code',
          label: 'State Code',
          sortable: true,
        },
        {
          key: 'active_city_count',
          label: 'Active City Count',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'inactive_city_count',
          label: 'InActive City Count',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'country',
          label: 'Country',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      json_fields: {
        State: {
          field: 'name',
          callback: value => `"${value}"`,
        },
        'State Code': {
          field: 'state_code',
          callback: value => `"${value}"`,
        },
        'Ref No.': 'ref_no',
        'Active City Count': 'active_city_count',
        'Inactive City Count': 'inactive_city_count',
        Country: {
          field: 'country.name',
          callback: value => `"${value}"`,
        },
      },
      rows: [],
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  watch: {
    page() {
      this.fetchState()
    },
    perPage() {
      this.fetchState()
    },
  },
  mounted() {
    // Set the initial number of items
    this.fetchState()
    this.totalRows = this.rows.length
  },
  methods: {
    onClickCreateState() {
      this.$refs.set_state.openModal(null, 'add')
    },
    async fetchState() {
      this.dataLoading = true
      this.rows = []
      try {
        const { data } = (await ResourceRepository.getStateAllList(this.page, this.filterQuery, this.perPage, this.sort))
        this.rows = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchStateNoPagination() {
      try {
        const { data } = (await ResourceRepository.getAllStateListListNoPagination(this.filterQuery, this.sort))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async onClickUpdate(id) {
      this.$refs.set_state.openModal(id, 'edit')
    },
    applyFilters() {
      this.fetchState()
    },
    clearFilters() {
      this.filters = {}
      this.$nextTick(() => {
        this.fetchState()
      })
    },
    handleChangePage(page) {
      this.page = page
      this.fetchState()
    },
    changePage(value) {
      this.perPage = value
    },
    onClickRefresh() {
      this.fetchState()
    },
    async onClickDelete(id) {
      return this.$swal({
        title: 'Confirm Delete',
        icon: 'info',
        text: 'Are you sure you want to delete this state?',
        showCancelButton: true,
        confirmButtonText: 'Yes, confirm!',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        backdrop: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.onClickConfirm(id)
        }
      })
    },
    async onClickConfirm(id) {
      try {
        const res = await ResourceRepository.deleteState(id)
        if (res.status === 200) {
          await this.fetchState()
          this.showSuccessMessage('State Deleted successfully')
        } else {
          this.showErrorMessage("Couldn't Delete State")
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
  },
}
</script>
<style scoped>
.custom-button-color {
  background-color: #4186f5 !important;
  border-color: #4186f5 !important;
}
</style>
